// extracted by mini-css-extract-plugin
module.exports = {"details":"Details_details__2-xGu","label":"Details_label__24DvT","value":"Details_value__2m8j0"};